// extracted by mini-css-extract-plugin
export default {"wrapper":"logoMobile_wrapper__IfBzW","line":"logoMobile_line__GOCyt","line2":"logoMobile_line2__gT3Jp"};